export default {
  close: 'Close',
  dataIterator: {
    pageText: '{0}-{1} od {2}',
    noResultsText: 'Nisu pronađeni odgovarajući zapisi',
    loadingText: 'Loading item...',
  },
  dataTable: {
    itemsPerPageText: 'Redova po stranici:',
    ariaLabel: {
      sortDescending: ': Sorted descending. Activate to remove sorting.',
      sortAscending: ': Sorted ascending. Activate to sort descending.',
      sortNone: ': Not sorted. Activate to sort ascending.',
    },
    sortBy: 'Sort by',
  },
  dataFooter: {
    itemsPerPageText: 'Stavaka po stranici:',
    itemsPerPageAll: 'Svi',
    nextPage: 'Sljedeća stranica',
    prevPage: 'Prethodna stranica',
    firstPage: 'Prva stranica',
    lastPage: 'Zadnja stranica',
  },
  datePicker: {
    itemsSelected: '{0} odabrano',
  },
  noDataText: 'Nema dostupnih podataka',
  carousel: {
    prev: 'Prethodna slika',
    next: 'Sljedeća vizuala',
  },
  calendar: {
    moreEvents: 'Još {0}',
  },
  fileInput: {
    counter: '{0} files',
    counterSize: '{0} files ({1} in total)',
  },
}
